import { CHANGE_LANG } from "../Translations/actions";
// import { SESSION_STATE_KEY } from "../../store";

const initialState = {
  user: null,
  token: null,
  error: null,
  is_confirmed: false,
};

export const types = {
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILED: "LOGIN_FAILED",
  CONFIRM_SUCCESS: "CONFIRM_SUCCESS",
  CONFIRM_FAILED: "CONFIRM_FAILED",
  LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
  ADD_LOYALTY_REWARD: "ADD_LOYALTY_REWARD",
  DELETE_LOYALTY_REWARD: "DELETE_LOYALTY_REWARD",
  ADD_CLIENT_PROFILE: "ADD_CLIENT_PROFILE",
  REMOVE_CLIENT_PROFILE: "REMOVE_CLIENT_PROFILE",
  UPDATE_NAVIGATION_CODFAG: "UPDATE_NAVIGATION_CODFAG",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.LOGIN_SUCCESS:
      const payload = JSON.parse(atob(action.payload.token.split(".")[1]));
      return {
        ...state,
        user: {
          ...payload,
          client_profile:
            payload.role === "CLIENT"
              ? { ...payload, email: payload.data?.email }
              : null,
        },
        token: action.payload.token,
        is_confirmed: true,
      };
      break;
    case types.LOGIN_FAILED:
      return {
        ...state,
        is_confirmed: false,
      };
      break;
    case types.CONFIRM_SUCCESS:
      return {
        ...state,
        is_confirmed: true,
      };
      break;
    case types.CONFIRM_FAILED:
      return {
        ...state,
        is_confirmed: false,
      };
      break;
    case types.LOGOUT_SUCCESS:
      return {
        ...state,
        is_confirmed: false,
        user: null,
        token: null,
      };
      break;
    case CHANGE_LANG:
      {
        if (
          state.user &&
          state.user.data &&
          state.user.data.lang !== action.payload
        ) {
          return {
            ...state,
            user: {
              ...state.user,
              data: {
                ...state.user.data,
                lang: action.payload,
              },
            },
          };
        } else {
          return state;
        }
      }
      break;
    case types.ADD_LOYALTY_REWARD:
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user?.data,
            loyalty_reward: action.payload,
          },
        },
      };
      break;
    case types.DELETE_LOYALTY_REWARD:
      return {
        ...state,
        user: {
          ...state.user,
          data: {
            ...state.user.data,
            loyalty_reward: undefined,
          },
        },
      };
      break;
    case types.ADD_CLIENT_PROFILE:
      return {
        ...state,
        user: {
          ...state.user,
          client_profile: action.payload,
        },
      };
      break;
    case types.REMOVE_CLIENT_PROFILE:
      return {
        ...state,
        user: {
          ...state.user,
          client_profile: null,
        },
      };
      break;
    case types.UPDATE_NAVIGATION_CODFAG:
      return {
        ...state,
        user: {
          ...state.user,
          nav_codfag: action.payload,
        },
      };
      break;
    default:
      return state;
      break;
  }
}
